'use client';

import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PalisadesPicnic = () => {
  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/research/palisadespicnic/thumb.jpg`}
            alt="Palisades Picnic Research"
            className="w-full h-full object-cover opacity-70"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <motion.div
          className="relative z-10 text-center px-6 max-w-4xl"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="text-white text-4xl md:text-6xl font-light tracking-wide">
            Picnic in the Palisades
          </h1>

          <p className="mt-6 text-white/80 text-base md:text-lg font-light leading-relaxed">
            Research project description goes here. You can edit this later.
          </p>
        </motion.div>
      </section>

      {/* Research Meta */}
      <section className="py-16 px-6 max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-sm text-gray-600">
          <div>
            <p className="uppercase tracking-widest text-xs text-gray-400">
              Research Type
            </p>
            <p className="mt-2">Spatial Research</p>
          </div>

          <div>
            <p className="uppercase tracking-widest text-xs text-gray-400">
              Status
            </p>
            <p className="mt-2">Ongoing</p>
          </div>

          <div>
            <p className="uppercase tracking-widest text-xs text-gray-400">
              Year
            </p>
            <p className="mt-2">2024</p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="pb-24 px-6 max-w-4xl mx-auto space-y-24">

        {[1,2,3,4].map((section) => (
          <motion.div
            key={section}
            className="space-y-10"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-2xl font-light text-gray-900">
              Section Heading {section}
            </h2>

            <p className="text-gray-700 leading-relaxed text-base">
              Paragraph content goes here. Replace this with your own research text.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[section * 2 - 1, section * 2].map((imgNum) => (
                <figure key={imgNum}>
                  <img
                    src={`${process.env.PUBLIC_URL}/images/research/palisadespicnic/${imgNum}.png`}
                    alt={`Figure ${imgNum}`}
                    className="h-64 md:h-80 w-auto mx-auto object-contain"
                  />
                  <figcaption className="text-xs text-gray-500 mt-2 text-center">
                    Figure {imgNum}: Description goes here.
                  </figcaption>
                </figure>
              ))}
            </div>
          </motion.div>
        ))}

      </section>

      <Footer />
    </>
  );
};

export default PalisadesPicnic;
